export default __webpack_public_path__ + "static/01 - Muru7.8colorcuadrado-32f1a0bd2ff9664274a1bef68d96c4a2.jpg";